module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"title\">Kontakt</div>\n<div class=\"content\">\n<div class=\"phone\"><%= model.phone %></div>\n<div class=\"contactForm linkTo\" data-button-action=\"@/de/kontakt-formular\">Kontaktformular</div>\n<%\nvar downloadUrl = '#';\nif(model.expose){\nif(model.expose[0]){\nmodel.expose = model.expose[0];\n}\nif(model.expose.url && (downloadUrl = model.expose.url)){\n%>\n<a class=\"download\" href=\"<%- downloadUrl %>\" target=\"_blank\">Download Exposé</a>\n<%\n}\n}\n%>\n</div>\n</div>"
  , __filename = "components/templates/project/gallery/contact.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"title\">Kontakt</div>\n<div class=\"content\">\n<div class=\"phone\">")
    ; __line = 4
    ; __append(escapeFn( model.phone ))
    ; __append("</div>\n<div class=\"contactForm linkTo\" data-button-action=\"@/de/kontakt-formular\">Kontaktformular</div>\n")
    ; __line = 6
    ; 
var downloadUrl = '#';
if(model.expose){
if(model.expose[0]){
model.expose = model.expose[0];
}
if(model.expose.url && (downloadUrl = model.expose.url)){

    ; __line = 13
    ; __append("\n<a class=\"download\" href=\"")
    ; __line = 14
    ; __append( downloadUrl )
    ; __append("\" target=\"_blank\">Download Exposé</a>\n")
    ; __line = 15
    ; 
}
}

    ; __line = 18
    ; __append("\n</div>\n</div>")
    ; __line = 20
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/gallery/contact.ejs

}